import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { requestType } from "../../types/common";
import { categoriesType } from "../../types/categories";
interface categoriesProp {
  categories: requestType<categoriesType[]>;
  selectedCategory?: categoriesType;
}
const initialState: categoriesProp = {
  categories: { loading: false },
};
export const categoriesSlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setCategories(state, action: PayloadAction<categoriesType[]>) {
      state.categories.loading = false;
      state.categories.data = action.payload;
    },
    setSelectedCategory(state, action: PayloadAction<categoriesType>) {
      state.selectedCategory = action.payload;
    },
  },
});
export const categoriesAction = categoriesSlice.actions;
export default categoriesSlice.reducer;
